<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false"  />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <el-col :span="24" class="content-right" >
                    <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <el-form-item class="item selcetItem" prop="themeId">
                            <el-select v-model="searchForm.themeId" :popper-append-to-body="false" placeholder="选择活动主题" filterable clearable  size="small">
                                <el-option
                                v-for="item in themeList"
                                :key="item.themeId"
                                :label="item.themeName"
                                :value="item.themeId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item class="item" prop="selectBrand">
                            <el-select v-model="searchForm.selectBrand" placeholder="选择品牌" size="small" clearable>
                                <el-option
                                v-for="item in brandOptions"
                                :key="item.brandId"
                                :label="item.brandName"
                                :value="item.abiBrandCode">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item class="item" prop="selectChannel">
                            <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" size="small" clearable>
                                <el-option
                                v-for="item in channelOptions"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="selectType">
                            <el-select v-model="searchForm.selectType" placeholder="选择形式" size="small" clearable>
                                <el-option
                                v-for="(key,value) in typeOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="selectLevel">
                            <el-select v-model="searchForm.selectLevel" placeholder="选择级别" size="small" clearable>
                                <el-option
                                v-for="(key,value) in levelOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                    <div class="card-box" >
                        <div class="card is-hover-shadow" v-for="(item) in cardData" :key="item.themeDetailId" >
                            <div class="left">
                            <div class="left-top">
                                <div class="top-name">{{getToolsname(item,'activityName','-')}}</div>
                                <div class="top-sign" v-if="item.gpThemeInfoDTO">{{getBluename(item.gpThemeInfoDTO.orgLevel)}}</div>
                            </div>
                            <!-- <div class="left-second">
                                <div>
                                    <span>{{getToolsname(item,'activityName','-')}}</span>
                                </div>
                                <div style="margin-left: 25px;">
                                    <span>已提报:</span>
                                    <span style="margin-left: 5px;">{{5}}场</span>
                                </div>
                            </div> -->
                            <div class="left-third" v-if="item.gpThemeInfoDTO">
                                <span class="font-weight-bold">活动时间：</span>
                                <span>{{getTime(item.gpThemeInfoDTO.themeStartTime)}}</span>
                                <span style="margin: 0px 5px;">-</span>
                                <span>{{getTime(item.gpThemeInfoDTO.themeEndTime)}}</span>
                            </div>
                            <div class="left-last">
                                <!-- <span>区域：</span>
                                <span style="margin-right: 25px;">{{getToolsname(item,'areaName','-')}}</span> -->
                                <span class="font-weight-bold">提报售点要求：</span>
                                <span>{{getToolsname(item,'typeName')}}</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="right-top">
                                <span>待提报</span>
                                <!-- <span>{{item.themeDetailStatusName}}</span> -->
                            </div>
                            <div class="right-btn">
                                <button class="btn-right" @click="reportAdd(item)">提报参与</button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div v-if="cardData.length == 0">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="pagination" v-if="cardData.length > 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    export default {
      name: 'activity-report-start',
      components: {
        ContentHeader,
      },
      data () {
        return {
            searchForm: {
                themeId:'',
                prId: '', // PR编码
                prName: '', // PR名称
                activityName: '', // 活动名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                searchStatus: '',
                page: 1,
                pageSize: 10,
                total:0,
                selectType: '', //形式
                selectLevel: '', //级别
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            typeOptions:[],
            levelOptions:[],
            cardData: [],
            loading: true,
            menuCode: '01',
            themeList:[]
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
        'searchForm.selectChannel': {
            handler (to, from) {
                this.getStyleMap()
                this.searchForm.selectType = ''
                this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
            },
        'searchForm.selectType': {
            handler (to, from) {
                this.getLevelMap()
                this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
        },
      },
      created () {
        this.init()
      },
      mounted () {
      },
      methods: {
        init () {
            this.getSelectChannel()
            this.getThemeNamelist ()
            this.getThemelist()
        },
        getToolsname (item,type,sign) {
            if (type == 'saleName') {
                let arr = item.gpActivityPocDTOList
                if (arr.length > 0) {
                    let name = arr.map((item)=>{
                        return item.pocName
                    }).join(sign)
                    return name
                }
            } else if (type == 'activityName') {
                let arr = []
                if (item.gpThemeInfoDTO) {
                    arr.push(item.gpThemeInfoDTO.themeName)
                }
                if (item.themeChannelName) {
                    arr.push(item.themeChannelName.split('|')[1])
                }
                if (item.themeStyleName) {
                    arr.push(item.themeStyleName)
                }
                if (item.themeLevelName) {
                    arr.push(item.themeLevelName)
                }
                let name = arr.map((item)=>{
                    return item
                }).join(sign)
                return name
            }
            else if (type == 'areaName') {
                let arr = []
                if (item.regionName) {
                    arr.push(item.regionName.split('|')[0])
                }else {
                    return
                }
                let name = arr.map((item)=>{
                    return item
                }).join(sign)
                return name
            }
            else if (type == 'typeName') {
                let pocRelateType = item.pocRelateType
                if (pocRelateType == '0') {
                    return '无售点'
                }else if (pocRelateType == '1') {
                    return '单售点'
                } else if (pocRelateType == '2') {
                    return '多售点'
                } else {
                    return 'error'
                }
            }
            else {
                return 'error'
            }
        },
        getBluename (name) {
            if (name == 'region') {
                return 'Region'
            } else if (name == 'bu') {
                return 'BU'
            } else if (name == 'hq') {
                return 'HQ'
            } else {
                return 'error'
            }
        },
        async getStyleMap () {
            let params = {
                channelCode:this.searchForm.selectChannel
            }
            const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
            if (data.resultCode === "0") {
                this.typeOptions = data.resultData.themeStyleMap || {};
            }
        },
        async getLevelMap () {
            let params = {
                styleCode:this.searchForm.selectType
            }
            const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
            if (data.resultCode === "0") {
                this.levelOptions = data.resultData.themeLevelMap || {};
            }
        },
        getChannel(a,b){
            let themeChannels = a
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        getThemeNamelist () {
            let params = {
            }
            gameplanApi.getReminnameList(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.themeList = res.data.resultData.themeNameList || []
                }
            })

        },
        getThemelist () {
            this.loading = true
            let params = {
                page: this.searchForm.page,
                pageSize: this.searchForm.pageSize,
                themeName: this.searchForm.activityName,
                themeChannelCode: this.searchForm.selectChannel,
                themeStyleCode: this.searchForm.selectType,
                themeLevelCode: this.searchForm.selectLevel,
                regionCode:'',
                themeId: this.searchForm.themeId
            }
            gameplanApi.getGamepalnRemainlist(params).then(res=>{
                if (res.data.resultCode === '0') {
                    let pageData = res.data.resultData.pageInfo
                    this.searchForm.page = Number(pageData.curPage)
                    this.searchForm.total = Number(pageData.totalCounts)
                    // this.themeList = res.data.resultData.themeNameList || []
                    if (res.data.resultData.themeDetailList == null) {
                        this.cardData = []
                    } else {
                        this.cardData = res.data.resultData.themeDetailList
                    }
                    this.loading = false
                } else {
                    this.loading = false
                    console.log('接口error');
                }
            })
        },
        async getSelectChannel () {
            // name=gpThemeChannelMap&type=list或map
            let params = {
                name:'gpThemeChannelMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.channelOptions = data.data.resultData.gpThemeChannelMap
        },
        async getSelectBrand () {
            let data =  await gameplanApi.getGamepalnBrandquery()
            this.brandOptions = data.data.resultData.btmpBrandDTOList
        },
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getThemelist()
        },
        queryForm (val) {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.page =1
                    this.getThemelist()
                } else {
                    return false;
                }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.page =1
            this.getThemelist()
        },
        // 提报参与
        reportAdd (item) {
            this.$router.push({path:'/gameplan/activity-report-add',query:{'themeDetailId':item.themeDetailId}})
        }
      }
    }
</script>
<style lang="scss" scoped>
    // .el-menu-item.is-active {
    //     // color: #fff;
    //     border: none;
    //     font-weight: bold;
    //     // background-color: rgba(51, 51, 51, 0.2) !important;
    // }
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    // .trade-nav-panel {
    //   width: 80%;
    //   margin: 0 auto;
    //   background: $base-white;
    //   .el-menu-item:last-child{
    //     border-bottom: 0;
    //   }
    //   ::v-deep .el-card__header {
    //     height: 70px;
    //     line-height: 35px;
    //   }
    //   ::v-deep .el-card__body {
    //     padding: 0;
    //   }
    //   .panel-header {
    //     font-size: 16px;
    //     font-weight: 700;
    //     color:#CD1231;
    //   }
    //   ::v-deep .el-menu {
    //     border-right: 0;
    //   }
    //   ::v-deep .el-menu-item {
    //     border-bottom: 1px solid $base-grey5;
    //   }
    //   ::v-deep .el-menu-item.is-active {
    //     color: $base-red;
    //   }
    // }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            .searchForm {
                margin: auto;
                width: 900px;
                .item {
                    width:130px;
                    ::v-deep .el-input__inner {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                .item-btn {
                    margin-left: 30px;
                }
                .selcetItem{
                    ::v-deep .el-select-dropdown__wrap {
                        max-height: 274px;
                        max-width: 200px;
                    }
                }
            }
        }
        .card-box {
            .card {
                margin: auto;
                width: 880px;
                min-height: 80px;
                display: flex;
                justify-content: flex-start;
                padding:10px 10px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                margin-bottom: 20px;
                .left {
                    text-align: left;
                    color: #101010;
                    width: 70%;
                    .left-top {
                        font-size: 18px;
                        display: flex;
                        .top-name {
                            font-weight: 600;
                            // padding: 2px 0px;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                        .top-sign {
                            // padding: 2px 8px;
                            color: #FFFFFF;
                            background-color: #40A5EE;
                            margin-left: 10px;
                            // border-radius: 3px;
                            // height: 20px;
                            padding: 0px 8px;
                            line-height: 18px;
                            height: 18px;
                            font-size: 14px;
                            margin-top: 2px;
                            font-weight: 600;
                        }
                        padding-bottom: 10px;
                    }
                    .left-second {
                        line-height: 20px;
                        display: flex;
                        padding-bottom: 10px;
                    }
                    .left-third {
                        line-height: 20px;
                        padding-bottom: 10px;
                    }
                    .left-last {
                        line-height: 20px;
                        padding-bottom: 10px;
                    }
                }
                .right {
                    flex: 1;
                    text-align: right;
                    position: relative;
                    .right-top {
                        line-height: 27px;
                        color: #CD1231 ;
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .right-btn {
                        position: absolute;
                        bottom: 5px;
                        right: 0;
                        // margin-top: 43px;
                        font-size: 14px;
                        text-align: right;
                        font-family: Microsoft Yahei;
                        .btn-left {
                            width: 84px;
                            height: 32px;
                            border-radius: 4px;
                            border: 1px solid #CD1231;
                            background-color: #FFFFFF;
                            color: #CD1231;
                            cursor: pointer;
                        }
                        .btn-right {
                            width: 84px;
                            height: 32px;
                            // padding: 4px 12px;
                            border-radius: 4px;
                            border: 1px solid #CD1231;
                            background-color: #CD1231;
                            color: #FFFFFF;
                            margin-left: 20px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
            text-align: center;
        }
      }
    }
</style>
